import { render } from "./ButtonIcon.vue?vue&type=template&id=75ee56ff&scoped=true"
const script = {}

import "./ButtonIcon.vue?vue&type=style&index=0&id=75ee56ff&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ee56ff"]])

export default __exports__